<template>
    <select v-bind:value="value" v-on:input="emit($event.target.value)">
        <option v-for="(option, key) in options" v-bind:value="key">{{ option }}</option>
    </select>
</template>

<script>
    export default {
        props: ['value', 'options'],
        methods: {
            emit: function(value) {
                this.$emit('input', value);
            }
        }
    };
</script>
